import React, {useState , useEffect} from 'react'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const rows = [
  { userId: 1, transactionId: 999,  userName: 'plasmatech8', change: Math.random() * 80, date: (new Date()) - 10000000000*Math.random()},
  { userId: 2, transactionId: 2,  userName: 'blazar', change: Math.random() * 80, date: (new Date()) - 10000000000*Math.random()},
  { userId: 3, transactionId: 3,  userName: 'Mr360', change: Math.random() * 80, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 4,  userName: 'A', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 5,  userName: 'B', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 6,  userName: 'C', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 7,  userName: 'D', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 8,  userName: 'E', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 9,  userName: 'F', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 10, userName: 'G', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 11, userName: 'H', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 12, userName: 'I', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 9, transactionId: 13, userName: 'J', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 14, userName: 'K', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 15, userName: 'L', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 16, userName: 'M', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
  { userId: 4, transactionId: 17, userName: 'N', change: Math.random() * 10 - 20, date: (new Date()) - 10000000000*Math.random() },
]

function ManagementHistoryTable() {

  // Data ordering
  const [orderBy, setOrderBy] = useState(null);
  const [orderDirection, setOrderDirection] = useState('asc');
  const [visibleData, setVisibleData] = useState([]);

  const handleChangeOrdering = (newOrderBy) => {
    const newOrderDirection = (
      newOrderBy === orderBy
      ? (orderDirection === 'asc' ? 'desc' : 'asc')
      : 'asc'
    )
    setOrderBy(newOrderBy)
    setOrderDirection(newOrderDirection)
    let newRows;
    switch (newOrderBy) {
      case 'transactionId':
        newRows = visibleData.sort((a, b) => a.transactionId < b.transactionId)
        break;
      case 'userName':
        newRows = visibleData.sort((a, b) => a.userName < b.userName)
        break;
      case 'change':
        newRows = visibleData.sort((a, b) => a.change < b.change)
        break;
      case 'type':
        newRows = visibleData.sort((a, b) => a.change < b.change)
        break;
      case 'date':
        newRows = visibleData.sort((a, b) => a.date < b.date)
        break;
      default:
        break;
    }
    setVisibleData(newOrderDirection === 'asc' ? newRows : newRows.reverse())
  }

  // Data pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // Data retrieval
  const [data, setData] = React.useState([])
  useEffect(()=> {
    setData(rows.sort((a,b) => a.transactionId < b.transactionId))
  }, [])
  useEffect(() => {
    setVisibleData(
      data.slice(page*rowsPerPage, (page+1)*rowsPerPage)
    )
  }, [rowsPerPage, page, data])


  // Display elements
  return (
    <div>
      <Paper>

      <Box padding={2} align='left'>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h6"
          >
          Share Management / Transactions
        </Typography>
      </Box>

      <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'transactionId'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('transactionId')}
                >
                Transaction ID
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'userName'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('userName')}
                >
                User
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'change'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('change')}
                >
                Change
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'type'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('type')}
                >
                Type
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'date'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('date')}
              >
                Date
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {

            visibleData.map(row => (
              <TableRow key={row.transactionId}>
                            <TableCell>{row.transactionId}</TableCell>
                            <TableCell>{row.userName}</TableCell>
                            <TableCell>{row.change}</TableCell>
                            <TableCell>{row.change > 0 ? 'Issued' : 'Revoke'}</TableCell>
                            <TableCell>{(new Date(row.date)).toString()}</TableCell>
                          </TableRow>
                      )
                      )
                    }
        </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      </Paper>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  )
}

export default ManagementHistoryTable
